import { CustomerDisplayActions } from 'src/common/redux/reducers/customer-display-reducer';
import { CustomerDisplayScreen } from 'src/customer-display/enum/customer-display.enum';
import {
  beginPaymentSession,
  enablePayments,
  inEnablePayment,
} from 'src/devices/payment/pinpad-operations';
import { LocalStorage } from '../../common/helpers/local-storage';
import { store } from '../../common/redux/configure-store';
import { LoginActions } from '../../common/redux/reducers/login-reducer';
import { swipeAhead } from './../../devices/payment/get-card-details';

export const unlockPos = async (reEnablePayments: boolean = false): Promise<void> => {
  store.dispatch(LoginActions.unlockPos());
  store.dispatch(CustomerDisplayActions.setScreen(CustomerDisplayScreen.LockedScreen));
  LocalStorage.removeLockUser();
  if (reEnablePayments && store.getState().pinPad.isPinpadConfigured) {
    if (!inEnablePayment()) {
      await enablePayments();
    }
    if (store.getState().transaction.transactionIdExists) {
      await beginPaymentSession();
      const balanceDue = store.getState().itemList.amountDue;
      if (balanceDue) {
        swipeAhead();
      }
    }
  }
};
